import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { decodeObject, decryptObject, generateSalt } from "../shared/utils/encryption";

const getEcryptedAccountDetails = () => {
  const encrypted_account_details = Cookies.get("accountDetails");
  if (!encrypted_account_details) {
    return {};
  }
  const decrypted_account_details = decodeObject(
    encrypted_account_details,
    process.env.REACT_APP_LOGIN_SALT
  );
  console.warn(decrypted_account_details, "account_details");
  return decrypted_account_details;
};
const account_details = getEcryptedAccountDetails() || {};
const hubs = account_details?.hubs || [];
const role = account_details?.role || [];
const account_id = account_details?.id || "";
const first_name = account_details?.first_name || "";
// Thunk to fetch roles from API
export const fetchRoles = createAsyncThunk("role/fetchRoles", async () => {
  try {
    const response = await getEcryptedAccountDetails();
    // const response = await api.get(roleBasedAPI);
    if (response?.role?.includes("vendor")) {
      response?.role.unshift("vendor");
    }
    if (response.results?.role?.length > 0) {
      // localStorage.setItem("role", response?.results?.role[0]);
      localStorage.setItem("roles", response?.results?.role);
    }

    // Store hub data in localStorage for page refresh scenarios
    if (response?.hubs?.length > 0) {
      localStorage.setItem("hubs", JSON.stringify(response.hubs));
    }
    return response;
  } catch (error) {
    throw error;
  }
});

const roleSlice = createSlice({
  name: "role",
  initialState: {
    data: account_details || {},
    roles: role || [],
    name: first_name || "",
    Id: account_id || "", // TODO Id-> id
    hubs: hubs || [], //add by bashar
    loading: false,
    error: null,
  },
  reducers: {
    // Additional reducers can be defined here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload.role;
        // state.name = action.payload.name;
        state.hubs = action.payload.hubs;
        state.name = action.payload.first_name;

        state.Id = action.payload.Id;
        state.data = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { roles } = roleSlice.actions; // No additional actions defined here

export default roleSlice.reducer;
